import { ContentState, EditorState } from "draft-js";
import htmlToDraft from "html-to-draftjs";
import * as R from "ramda";
import * as React from "react";
import { Editor } from "react-draft-wysiwyg";
import styled from "styled-components";
import { prependParagraph } from "./Editor.helpers";

const HTMLRenderContainer = styled.div`
  display: block;
  margin: 0.5rem;
`;

export interface IHTMLRendererProps {
  placeholder?: string;
  source: Nullable<string>;
}

const trimExtraDivInContent = (initial: string) => {
  // Backend may have wrapped HTML content with an extra div, so we check
  // for one and remove it to display if the content is not trimmed then an extra white space <br> is added on top
  const original = initial.trim();
  const length = original.length;
  if (original.slice(0, 5) === "<div>" && original.slice(length - 6, length) === "</div>") {
    return original.slice(5, length - 6);
  }
  return original;
};

const sanitizeHTML = R.pipe(trimExtraDivInContent, prependParagraph);

export const HTMLRenderer: React.SFC<IHTMLRendererProps> = ({ source, placeholder }) => {
  const content = R.isNil(source)
    ? EditorState.createEmpty()
    : EditorState.createWithContent(ContentState.createFromBlockArray(htmlToDraft(sanitizeHTML(source)).contentBlocks));
  return (
    <HTMLRenderContainer>
      <Editor placeholder={placeholder} editorState={content} readOnly={true} toolbarHidden={true} />
    </HTMLRenderContainer>
  );
};
